import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sm-card',
  templateUrl: './sm-card.component.html',
  styleUrls: ['./sm-card.component.scss']
})
export class SmCardComponent {
  @Input() isMetric: Boolean = false;
  @Input() label: string = null;
  @Input() stat: string = null;
  @Input() desc: string = null;
  @Input() icon: string = null;
  @Input() progress: any = null;
  @Input() panelColor: string = null;
  @Input() iconColor: string = null;
  @Input() title: string = null;
  @Input() subtitle: string = null;
  @Input() count: any = null;
  @Input()
  badgeColor: string = null;

  get statusBadgeColor() {
    return this.badgeColor;
  }

  @Output() onDblClick = new EventEmitter<any>();
  @Input()
  allowCollapse: boolean = false;

  @Input()
  collapsed: boolean = false;

  @Input()
  iconSecondary: string = ''; //secondary icon to the right of title -- used for special indicators

  @Input()
  iconSecondaryTooltip: string = null; //tool tip for secondary icon to the right of title

  customColor: string = null;

  /** Card icons are either a Font Awesome class or an icon name. */
  isFontAwesomeIcon(icon: string): boolean {
    return !icon || icon.startsWith('fa');
  }

  /** Tolerates the legacy `unity-icon unity-icon-x` spelling still present in tenant config. */
  auroraIconName(icon: string): string {
    return icon ? icon.split(/\s+/).pop().replace('unity-icon-', '') : '';
  }

  onDoubleClick() {
    this.onDblClick.emit();
  }

  convertColors() {
    if (this.panelColor) {
      switch (this.panelColor.toUpperCase()) {
        case '#B3E6B3':
          return 'status-success';
        case '#FF9999':
          return 'status-error';
        case '#FFEB99':
          return 'status-warning';
        case '#CCCCCC':
          return 'status-info';
        default:
          return (this.customColor = this.panelColor);
      }
    }
  }
}
